import useRouteGuard from 'hooks/useRouteGuard';
import other from './other';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const useMenuItems = (): { items: NavItemType[] } => {
    const enabledPaths = useRouteGuard();
    const items = { ...other };
    if (items.children) {
        items.children = items.children.filter((menuItem) => {
            return enabledPaths.includes(menuItem.url || '');
        });
    }
    return {
        items: [items]
    };
};

export default useMenuItems;
